import { z } from 'zod';
import { localeSchema } from './schemas.js';
/** Camp traduïble: { ca, es, en, de }, qualsevol idioma pot faltar (§11.2). */
export const i18nTextSchema = z.partialRecord(localeSchema, z.string());
export const translationStatusSchema = z.enum(['missing', 'machine', 'reviewed', 'outdated']);
// Viu a locales.ts (sense zod), perquè la part pública la pugui fer servir.
export { resolveI18nText } from './locales.js';
